<template>
  <div :class="$style.navBar" v-if="showNavBar">
    <nav :class="$style.navInner" class="container">
      <div :class="$style.left">
        <router-link to="/" tag="a" :class="$style.logo">
          <svg width="28" height="35" viewBox="0 0 28 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M27.1553 0H15.5173V35H27.1553V0Z" fill="var(--primary)" />
            <path d="M11.638 0H0V19.4444H11.638V0Z" fill="var(--primary)" />
            <path d="M11.638 23.3333H0V35H11.638V23.3333Z" fill="var(--primary)" />
          </svg>
          <span :class="$style.brandName">Aurizor</span>
        </router-link>
      </div>
      <div :class="$style.right">
        <!-- New Website button with dropdown -->
        <div :class="$style.newWebsiteWrapper" v-if="showNavBar && user && user._id" ref="newWebsiteWrapper">
          <button :class="[$style.newWebsiteBtn, showNewMenu && $style.newWebsiteBtnActive]" @click.stop="showNewMenu = !showNewMenu">
            <svg :class="$style.btnIconPlus" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 5v14M5 12h14"/>
            </svg>
            New Website
            <svg :class="[$style.btnChevron, showNewMenu && $style.btnChevronOpen]" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="6 9 12 15 18 9"/>
            </svg>
          </button>
          <transition name="dropdown-fade">
            <div :class="$style.newMenu" v-if="showNewMenu">
              <a :href="orderUrl" target="_blank" :class="$style.newMenuItem" @click="showNewMenu = false">
                <div :class="[$style.newMenuIcon, $style.newMenuIconPlans]">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
                  </svg>
                </div>
                <div>
                  <div :class="$style.newMenuLabel">Browse Plans</div>
                  <div :class="$style.newMenuDesc">Purchase a new hosting plan</div>
                </div>
              </a>
              <button :class="$style.newMenuItem" @click="goMigrate">
                <div :class="[$style.newMenuIcon, $style.newMenuIconMigrate]">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="7 10 12 15 17 10"/>
                    <line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                </div>
                <div>
                  <div :class="$style.newMenuLabel">Migrate Site</div>
                  <div :class="$style.newMenuDesc">Move an existing WordPress site</div>
                </div>
              </button>
            </div>
          </transition>
        </div>

        <div :class="$style.userWrapper" ref="userWrapper">
          <div :class="[$style.userDp, showUserMenu && $style.userDpActive]" @click.stop="showUserMenu = !showUserMenu">
            <p>{{ userDPName }}</p>
          </div>
          <transition name="dropdown-fade">
            <div :class="$style.userMenu" v-if="showUserMenu">
              <!-- User Info -->
              <div :class="$style.userInfo">
                <div :class="$style.userAvatar">{{ userDPName }}</div>
                <div :class="$style.userName">{{ user.displayName }}</div>
                <div :class="$style.userEmail">{{ user.email }}</div>
              </div>
              
              <div :class="$style.menuDivider"></div>
              
              <!-- What's New -->
              <router-link :class="$style.userMenuItem" to="/whats-new" @click.native="showUserMenu = false">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"/>
                  <path d="M2 17l10 5 10-5"/>
                  <path d="M2 12l10 5 10-5"/>
                </svg>
                What's New
                <span :class="$style.versionBadge">v2.0</span>
              </router-link>
              
              <!-- Settings -->
              <router-link :class="$style.userMenuItem" to="/settings" @click.native="showUserMenu = false">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="3"/>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                </svg>
                Settings
              </router-link>

              <!-- Feedback / Feature Requests -->
              <a
                :class="$style.userMenuItem"
                :href="feedbackUrl"
                target="_blank"
                rel="noopener noreferrer"
                @click="showUserMenu = false"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
                </svg>
                Feedback & Ideas
              </a>
              
              <div :class="$style.menuDivider"></div>
              
              <!-- Logout -->
              <button :class="[$style.userMenuItem, $style.logoutItem]" @click="logout">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
                  <polyline points="16,17 21,12 16,7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
                Logout
              </button>
            </div>
          </transition>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/axios";

export default {
  name: "Navbar",
  data() {
    return {
      showNewMenu: false,
      showUserMenu: false,
    };
  },
  computed: {
    ...mapGetters({ user: "GET_USER", showNavBar: "SHOW_NAV_BAR" }),
    userDPName() {
      if (this.user.displayName) return this.user.displayName.charAt(0);
      return "";
    },
    orderUrl() {
      return process.env.VUE_APP_ORDER_URL || 'https://orcus.one/store/managed-wordpress';
    },
    feedbackUrl() {
      return process.env.VUE_APP_FEEDBACK_URL || 'https://feedback.aurizor.com/';
    },
  },
  methods: {
    async logout() {
      try {
        // Destroy phpMyAdmin sessions server-side
        try {
          await axios.post("/phpmyadmin/logout");
        } catch (_) { /* best-effort */ }

        await axios.post("/auth/logout");
        await this.$router.push("/login");
      } catch (err) {
        this.$toasted.error("Something went wrong");
      }
    },
    goMigrate() {
      this.showNewMenu = false;
      // Navigate to dashboard home and let it open the migrate modal
      if (this.$route.name !== 'DashHome') {
        this.$router.push({ name: 'DashHome', query: { migrate: '1' } });
      } else {
        // Emit event so DashHome can open the modal
        this.$root.$emit('open-migrate-modal');
      }
    },
    handleClickOutside(e) {
      if (this.showNewMenu && this.$refs.newWebsiteWrapper && !this.$refs.newWebsiteWrapper.contains(e.target)) {
        this.showNewMenu = false;
      }
      if (this.showUserMenu && this.$refs.userWrapper && !this.$refs.userWrapper.contains(e.target)) {
        this.showUserMenu = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="scss" module>
.nav-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border);
}

.nav-inner {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left {
  .logo {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;

    svg {
      height: 28px;
      width: auto;
    }
  }

  .brand-name {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
    letter-spacing: -0.02em;
  }
}

.right {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* New Website button + dropdown */
.new-website-wrapper {
  position: relative;
}

.new-website-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 14px 8px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(99, 102, 241, 0.3);

  &:hover {
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 3px rgba(99, 102, 241, 0.3);
  }
}

.new-website-btn-active {
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.4);
}

.btn-icon-plus {
  opacity: 0.9;
}

.btn-chevron {
  opacity: 0.7;
  transition: transform 0.2s ease;
  margin-left: -2px;
}

.btn-chevron-open {
  transform: rotate(180deg);
}

.new-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 272px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.04);
  z-index: 200;
  padding: 6px;
  animation: menuAppear 0.15s ease-out;
}

@keyframes menuAppear {
  from {
    opacity: 0;
    transform: translateY(-6px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.new-menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  border-radius: 10px;
  transition: background 0.15s ease;

  &:hover {
    background: #f5f5ff;
  }
}

.new-menu-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.new-menu-icon-plans {
  background: rgba(99, 102, 241, 0.1);
  color: #6366f1;
}

.new-menu-icon-migrate {
  background: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.new-menu-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  line-height: 1.3;
}

.new-menu-desc {
  font-size: 11.5px;
  color: var(--text-secondary);
  margin-top: 2px;
  line-height: 1.3;
}

/* User dropdown */
.user-wrapper {
  position: relative;
}

.user-dp {
  background: linear-gradient(135deg, #667EEA, #764BA2);
  width: 36px;
  height: 36px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;

  p {
    font-size: 14px;
    color: #fff;
    font-weight: 600;
    text-transform: uppercase;
  }
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  }
}

.user-dp-active {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.user-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 240px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.04);
  z-index: 200;
  padding: 6px;
  animation: menuAppear 0.15s ease-out;
}

.user-info {
  padding: 12px;
  text-align: center;
}

.user-avatar {
  width: 48px;
  height: 48px;
  margin: 0 auto 8px;
  background: linear-gradient(135deg, #667EEA, #764BA2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
}

.user-email {
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 2px;
}

.menu-divider {
  height: 1px;
  background: var(--border);
  margin: 6px 0;
}

.user-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  transition: background 0.15s ease;

  svg {
    color: var(--text-secondary);
  }

  &:hover {
    background: #f5f5ff;
    
    svg {
      color: #6366f1;
    }
  }
}

.logout-item {
  color: var(--danger);
  
  svg {
    color: var(--danger);
  }
  
  &:hover {
    background: var(--danger-light);
  }
}

.version-badge {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  background: linear-gradient(135deg, #6366f1, #7c3aed);
  color: #fff;
  border-radius: 4px;
}
</style>
